import ModuleDto from '../models/service/ModuleDto'
import { ChapterLocation } from '../models/util/Location'

const getTasksByLocation = (modules: ModuleDto[], chapterLocation: ChapterLocation) => {
  const { modulePosition, chapterPosition } = chapterLocation
  return modules[modulePosition - 1]?.chapters[chapterPosition - 1]?.tasks
}

export default getTasksByLocation
